/*
 * @Author: liyu
 * @Date: 2022-04-25 15:11:22
 * @LastEditTime: 2022-04-25 15:19:08
 * @Description: file content
 * @FilePath: /sensors-www/src/components/Entertainment/EntertainmentButton/index.tsx
 */
import React ,{ ButtonHTMLAttributes, AnchorHTMLAttributes } from "react";
import * as styles from "./index.module.less";
import Button from 'components/Base/Button'
export enum ButtonType {
    Default = 'default',
    Primary = 'primary',
    Blue = 'blue',
    Secondary = 'secondary',
    Ghost = 'ghost',
    Text = 'text',
    Link = 'link',
    Gradients = 'gradients',
  }
interface BaseButtonProps {
    className?: string
    size?: string
    href?: string
    ghost?: boolean
    btnType?: ButtonType | string
    plain?: boolean
    round?: boolean
    icon?: string
    useLink?: boolean
}
type NativeButtonProps = BaseButtonProps & ButtonHTMLAttributes<HTMLElement>
type AnchorButtonProps = BaseButtonProps & AnchorHTMLAttributes<HTMLElement>
export type ButtonProps = Partial<NativeButtonProps & AnchorButtonProps>
const EntertainmentButton:React.FC<ButtonProps> = (props) => {
    return (<>
        <Button className={styles.entertainmentButton} {...props}/>
    </>)
}

export default EntertainmentButton